import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { User, Heart, Brain, Sparkles, Target } from 'lucide-react';

const Persona = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a1e 0%, #1a0a2e 100%)',
      padding: '2rem',
      color: '#fff'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #ba55d3, #ff00ff)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Persoma Consultation
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            Personalized AI guidance tailored to your unique consciousness, goals, and context
          </p>
        </div>

        {/* What is Persoma */}
        <Card style={{
          padding: '2.5rem',
          background: 'linear-gradient(135deg, rgba(186,85,211,0.2), rgba(255,0,255,0.1))',
          border: '2px solid #ba55d3',
          marginBottom: '3rem',
          textAlign: 'center'
        }}>
          <Sparkles size={48} style={{ color: '#ba55d3', margin: '0 auto 1rem' }} />
          <h2 style={{ fontSize: '2rem', color: '#ba55d3', marginBottom: '1rem' }}>What is Persoma?</h2>
          <p style={{ color: '#ccc', fontSize: '1.1rem', lineHeight: '1.8', maxWidth: '700px', margin: '0 auto' }}>
            Persoma is a personalized consultation system that adapts to <strong>your</strong> consciousness level, 
            communication style, goals, and current life context. Unlike standard AI that treats everyone the same, 
            Persoma learns from your interactions to provide increasingly personalized guidance.
          </p>
        </Card>

        {/* Features */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '2rem',
            background: 'rgba(10, 10, 30, 0.8)',
            border: '1px solid rgba(186, 85, 211, 0.3)'
          }}>
            <User size={40} style={{ color: '#ba55d3', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', color: '#ba55d3', marginBottom: '1rem' }}>Your Profile</h3>
            <p style={{ color: '#888', lineHeight: '1.8' }}>
              Build a comprehensive profile including your values, goals, communication preferences, and decision-making patterns.
            </p>
          </Card>

          <Card style={{
            padding: '2rem',
            background: 'rgba(10, 10, 30, 0.8)',
            border: '1px solid rgba(255, 0, 255, 0.3)'
          }}>
            <Brain size={40} style={{ color: '#ff00ff', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', color: '#ff00ff', marginBottom: '1rem' }}>Adaptive Learning</h3>
            <p style={{ color: '#888', lineHeight: '1.8' }}>
              The AI learns from every interaction, becoming more attuned to your thought patterns and needs over time.
            </p>
          </Card>

          <Card style={{
            padding: '2rem',
            background: 'rgba(10, 10, 30, 0.8)',
            border: '1px solid rgba(0, 255, 255, 0.3)'
          }}>
            <Target size={40} style={{ color: '#00ffff', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', color: '#00ffff', marginBottom: '1rem' }}>Contextual Guidance</h3>
            <p style={{ color: '#888', lineHeight: '1.8' }}>
              Advice is tailored to your current situation, long-term goals, and personal philosophy.
            </p>
          </Card>
        </div>

        {/* Consultation Types */}
        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.8)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.8rem', color: '#ba55d3', marginBottom: '1.5rem' }}>Consultation Types</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
            <Button variant="outline" style={{ border: '1px solid rgba(186, 85, 211, 0.5)', color: '#ba55d3', padding: '1rem' }}>
              Life Decisions
            </Button>
            <Button variant="outline" style={{ border: '1px solid rgba(0, 255, 255, 0.5)', color: '#00ffff', padding: '1rem' }}>
              Career Guidance
            </Button>
            <Button variant="outline" style={{ border: '1px solid rgba(0, 255, 136, 0.5)', color: '#00ff88', padding: '1rem' }}>
              Personal Growth
            </Button>
            <Button variant="outline" style={{ border: '1px solid rgba(255, 0, 255, 0.5)', color: '#ff00ff', padding: '1rem' }}>
              Relationship Advice
            </Button>
          </div>
        </Card>

        {/* Start Consultation */}
        <Card style={{
          padding: '3rem',
          background: 'linear-gradient(135deg, rgba(186,85,211,0.1), rgba(255,0,255,0.1))',
          border: '2px solid #ba55d3',
          textAlign: 'center'
        }}>
          <Heart size={48} style={{ color: '#ba55d3', margin: '0 auto 1rem' }} />
          <h2 style={{ fontSize: '2rem', color: '#ba55d3', marginBottom: '1rem' }}>Begin Your Persoma Journey</h2>
          <p style={{ color: '#ccc', fontSize: '1.1rem', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem' }}>
            Create your profile and start receiving personalized guidance that evolves with you.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #ba55d3, #ff00ff)',
            color: '#fff',
            fontWeight: 'bold',
            padding: '1rem 2.5rem',
            fontSize: '1.1rem'
          }}>
            Create Profile
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Persona;